import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation, useNavigate } from 'react-router-dom';

import Home from './Pages/LandingPages/Home';
import Contact from './Pages/LandingPages/Contact';
import Terms from './Pages/LandingPages/Terms';
import Privacy from './Pages/LandingPages/Privacy';
import PageNotFound from './Pages/LandingPages/PageNotFound';

const APPLICATION_HOSTNAME = process.env.REACT_APP_APPLICATION_HOSTNAME || 'https://toolover.vercel.app/app';

const landingPageRoutes = [
  '/', '/contact', '/terms', '/privacy', '/404'
]

function LandingPage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const matchedRoute = landingPageRoutes.includes(location.pathname);
    if (!matchedRoute) {
      navigate('/404')
    }
  }, [location])

  return (
    <>
      <nav className="fixed z-50 w-full bg-white border-b border-gray-200 sm:py-2 dark:bg-gray-800 dark:border-gray-700">
        <div className="container py-3 mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-start">
              <Link to='/' className="flex mr-4">
                <img
                  src="images/logo.png"
                  className="h-8 mr-3"
                  alt="TOOlover Logo"
                />
                <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
                  TOOlover
                </span>
              </Link>
              <div className="hidden sm:flex sm:ml-6">
                <ul className="flex space-x-8">
                  <li>
                    <Link to='/' className="text-sm font-medium text-gray-700 hover:text-primary-700 dark:text-gray-400 dark:hover:text-primary-500">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to='/contact' className="text-sm font-medium text-gray-700 hover:text-primary-700 dark:text-gray-400 dark:hover:text-primary-500">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <a href={APPLICATION_HOSTNAME} className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
                <svg
                  className="w-5 h-5 mr-2 -ml-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                  />
                </svg>
                Go To App
              </a>
              {/* <a
                href="#"
                className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
              >
                <svg
                  className="w-5 h-5 mr-2 -ml-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                  />
                </svg>
                Login/Register
              </a> */}
              <button
                data-collapse-toggle="mobile-menu"
                type="button"
                className="inline-flex items-center justify-center p-2 ml-3 text-gray-400 rounded-lg sm:hidden hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-300 dark:hover:bg-gray-700 dark:hover:text-white"
                aria-controls="mobile-menu-2"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
                <svg
                  className="hidden w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="hidden sm:hidden" id="mobile-menu">
          <ul className="pt-2">
            <li>
              <Link
                to='/contact'
                className="block py-2 pl-3 pr-4 text-base font-normal text-gray-900 bg-gray-100 dark:bg-gray-700 dark:text-white"
              >
                Contact Us
              </Link>
            </li>
            <li>
              <Link
                to='/privacy'
                className="block py-2 pl-3 pr-4 text-base font-normal text-gray-900 bg-gray-100 dark:bg-gray-700 dark:text-white"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to='/terms'
                className="block py-2 pl-3 pr-4 text-base font-normal text-gray-900 bg-gray-100 dark:bg-gray-700 dark:text-white"
              >
                Terms &amp; Conditions
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <main className="bg-gray-50 dark:bg-gray-900 landingPageBgStyle">
       <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/404" element={<PageNotFound />} />
      </Routes>
      </main>
      <footer className="py-12 bg-white xl:py-24 dark:bg-gray-800">
        <div className="container px-4 mx-auto xl:px-0">
          <div className="grid gap-12 xl:grid-cols-6 xl:gap-24">
            <div className="col-span-2">
              <a href="/" className="flex mr-4">
                <img
                  src="images/logo.png"
                  className="h-16 mr-3"
                  alt="TOOlover Logo"
                />
                <span className="self-center -mt-5 text-xl font-semibold whitespace-nowrap dark:text-white">
                  Boost Your Work Productivity with <br/> All-in-one Toolbox.
                </span>
              </a>
              <p className="max-w-lg mt-4 text-gray-500 dark:text-gray-400">
                TOOlover brings all online tools together. If you got tired of bookmarking a single website for each online tool, you are in right place.
                <br/><br/>
                TOOlover has designed as simple as possible to make it easier to focus on functionality of the tool. Main aim of the tools is to perform the operation in minimum steps with a clear UI/UX.
                <br/><br/>
                Start to use TOOlover and forget all other tools you use forever.
              </p>
            </div>
            <div>
              <h3 className="mb-6 text-sm font-semibold text-gray-600 uppercase dark:text-white">
                Follow us
              </h3>
              <ul>
                <li className="mb-4">
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                    className="font-normal text-gray-600 hover:underline dark:text-gray-400"
                  >
                    Github
                  </a>
                </li>
                <li className="mb-4">
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                    className="font-normal text-gray-600 hover:underline dark:text-gray-400"
                  >
                    Twitter
                  </a>
                </li>
                <li className="mb-4">
                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                    className="font-normal text-gray-600 hover:underline dark:text-gray-400"
                  >
                    Facebook
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="mb-6 text-sm font-semibold text-gray-600 uppercase dark:text-white">
                Legal
              </h3>
              <ul>
                <li className="mb-4">
                  <Link to='/privacy' className="font-normal text-gray-600 hover:underline dark:text-gray-400">
                  Privacy Policy
                  </Link>
                </li>
                <Link to='/terms' className="font-normal text-gray-600 hover:underline dark:text-gray-400">
                  Terms &amp; Conditions
                </Link>
              </ul>
            </div>
            <div>
              <h3 className="mb-6 text-sm font-semibold text-gray-600 uppercase dark:text-white">
                Contact Us
              </h3>
              <ul>
                <li className="mb-4">
                  <Link to='/contact' className="font-normal text-gray-600 hover:underline dark:text-gray-400">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <hr className="my-8 border-gray-200 lg:my-12 dark:border-gray-700" />
          <span className="block text-center text-gray-600 dark:text-gray-400">
            © 2024 TOOlover. All rights reserved.
          </span>
        </div>
      </footer>
    </>

  )
}

export default LandingPage;
